/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Onbekende_DocentInputs */

const nl_planning_rooster_onbekende_docent = /** @type {(inputs: Planning_Rooster_Onbekende_DocentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbekende docent`)
};

/**

* @param {Planning_Rooster_Onbekende_DocentInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_onbekende_docent = /** @type {((inputs?: Planning_Rooster_Onbekende_DocentInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Onbekende_DocentInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_onbekende_docent(inputs)
});
export { planning_rooster_onbekende_docent as "planning.rooster.onbekende_docent" }